module.exports = __webpack_public_path__ + "img/Richard.7831f423.jpg";